<template>
<transition name="show">
<div v-if="flag" class="point">{{message}}</div>
</transition>
</template>

<script>
export default {
  data() {
    return {
      flag: false,
      message: 'Hello world',
    };
  },
};
</script>

<style lang="scss" scoped>
  .show-enter-active {
  transition: all .8s ease;
}

.show-enter{
  opacity: 0;
}
.show-enter-to {
  opacity: 1;
}
.show-leave-active {
     transition: all .8s ease;
}
 .show-leave-to {
     opacity: 0;
 }
 .show-leave{
      opacity: 1;
 }
.point{
    position: fixed;
    top:50%;
    left: 50%;
     transform: translate(-50%, -50%);
    z-index: 1000;
    height:40px;
    line-height:40px;
    padding: 0px 10px;
    border-radius:5px;
    color: white;
    background-color:rgba($color: #000000, $alpha: 0.7);
     animation: myfirst .5s;
}
@keyframes myfirst
{
    from {opacity:0}
    to {opacity:1}
}

</style>



// WEBPACK FOOTER //
// src/components/Point.vue